import React, { createContext, useState, useContext } from 'react';

// Initial state object
const initialState = {
  PatientID: "",
  proxyID: "",
};

// Create the context
const StateContext = createContext(undefined);

// StateProvider component that provides state to the app
export const StateProvider = ({ children }) => {
  const [searchstate, setsearchState] = useState(initialState);

  // Function to reset the search state back to initial values
  const resetSearchState = () => {
    setsearchState(initialState);
  };

  return (
    <StateContext.Provider value={{ searchstate, setsearchState, resetSearchState }}>
      {children}
    </StateContext.Provider>
  );
};

// Custom hook to access the context
export const useStateContext = () => {
  const context = useContext(StateContext);
  
  if (!context) {
    throw new Error('useStateContext must be used within a StateProvider');
  }

  return context;
};
